export default __webpack_public_path__ + "static/media/triceps_kickback_end.cc15903b.svg";